import React, { useEffect, useRef } from 'react';

interface AudioProps {
  autoPlay?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  audioTrack?: any;
  id: string;
}

const Audio: React.FC<AudioProps> = ({ autoPlay = true, audioTrack, id }) => {
  const audioElement = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audioNode = audioElement.current;
    if (audioNode && audioTrack) {
      audioTrack.attach(audioNode).catch((error: Error) => {
        console.error('Error attaching audio track:', error);
      });
    }

    return () => {
      if (audioNode && audioTrack) {
        audioTrack.detach(audioNode);
      }
    };
  }, [audioTrack]);

  return <audio autoPlay={autoPlay} id={id} ref={audioElement} />;
};

export default Audio;
